<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {setOS,getUser} from './utils/storageUtil';
import $ from '../node_modules/jquery/src/jquery';
export default {
  name: 'app',
  created(){
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if(isAndroid){
      setOS({
        os: 'android'
      })
    }
    if(isiOS){
      setOS({
        os: 'ios'
      })
    }
  },
  mounted() {
    // window.jump=this.jump;
  },
  methods:{
    // jump(info){
    //   this.$router.push({name:'message'})
    // }
  }
}
</script>


<style lang="stylus" scoped>
#app {
    height: 100%;
    font-family: 'miui, PingFangSC-Regular, Microsoft Yahei'
    color: #333
}
</style>
